"use client";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/CardList/CardList.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CardList = forwardRef(function CardList2({ title, cards }, ref) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref,
      className: "flex flex-col gap-24 lg:gap-40 justify-center items-center py-40 lg:py-80 px-24 2xl:px-0",
      children: [
        title && /* @__PURE__ */ jsx(
          "h3",
          {
            dangerouslySetInnerHTML: { __html: title },
            className: "font-display text-4xl lg:text-6xl font-bold leading-[38px] lg:leading-9 text-center"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "flex md:grid lg:flex flex-col lg:flex-row md:grid-cols-2 gap-16 lg:gap-40 justify-center lg:justify-between items-center lg:items-stretch w-full max-w-7xl", children: cards.map(({ iconName, description, title: title2 }, index) => /* @__PURE__ */ jsxs(
          "div",
          {
            className: "flex flex-col gap-16 justify-center items-center p-24 lg:p-40 w-full bg-gradient-to-t from-[#EFF4F8] to-white rounded-md lg:rounded-2xl border-2 border-display-200",
            children: [
              /* @__PURE__ */ jsx("div", { className: "min-w-max", children: /* @__PURE__ */ jsx(
                Icon_default,
                {
                  name: iconName,
                  className: `w-48 h-48 text-stone-500 ${iconName === "arrowUpRight" && "fill-current"}`
                }
              ) }),
              /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-16 items-center", children: [
                /* @__PURE__ */ jsx("p", { className: "font-display text-3xl lg:text-4xl font-bold leading-7 lg:leading-8 text-center text-display-900", children: title2 }),
                /* @__PURE__ */ jsx("p", { className: "text-lg lg:text-xl leading-[26px] lg:leading-5 text-center text-display-900", children: description })
              ] })
            ]
          },
          index
        )) })
      ]
    }
  );
});
var CardList_default = CardList;

export {
  CardList_default
};
